import styled from 'styled-components';

export const ModalContainer =  styled.div(
    /* width: 675px; */
    props => `position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        background-color: #fff;
        border-radius: 1rem;
        z-index: 11;
    `
)

export const MobileModalContainerv = styled.div(
    props => `width: 100%;
        position: fixed;
        display: flex;
        flex-direction: column;
        left: 0;
        bottom: 0;
        top: unset;
        transform: none;
        background-color: #fff;
        z-index: 11;
    `
)

export const ModalBackdrop = styled.div(
    props =>  `width: 100%;
        height: 100%;
        position: fixed;
        left:0;
        top: 0;
        z-index: 10;
        background-color: rgba(0,0,0,0.7);
    `
)